import { Dashboard, Snop } from "../../../../assets/svg-icons";
export const SNOP = {
  name: "S&OP",
  shortName: "S&OP",
  route: "/snop",
  icon: Snop,
  permissions: ["SNOP_VIEW"],
  routePermissions: ["SNOP_VIEW"],
  extraRoutes: [
    {
      route: "/snop/dashboard",
      permissions: ["SNOP_DASHBOARD"],
    },
    {
      route: "/snop-detail",
      permissions: ["SNOP_VIEW"],
    },
    {
      route: "/snop/create",
      permissions: ["SNOP_VIEW"],
    },
    {
      route: "/snop/setup",
      permissions: ["SNOP_VIEW"],
    },
  ],
};

export const DASHBOARD = {
  name: "Dashboard",
  shortName: "Home",
  route: "/snop/dashboard",
  icon: Dashboard,
  permissions: ["SNOP_DASHBOARD"],
};
